

























































































































import {Component, Vue} from "vue-property-decorator";
import AppFooter from "../../layout/AppFooter.vue";
import Menu from "../../layout/Menu.vue";

@Component({
    components: {
        AppFooter,
        Menu,
    }
})

export default class UserLayout extends Vue {
    color : String = 'blue';
    mode:String = '';
    snackbar:Boolean = false;
    text: string =  'Ana Sayfaya gitmek istiyor musunuz?';
    timeout: number = 3000;
    x: string | null = null;
    y: string | null = 'top';
    drawer: any = null;

    /** Şube seçicideki seçenekler */
    get siteOptions(){
        return this.$store.getters.sites.map((site:any)=>({
            text: site.name + (Number(site.enabled) === 1 ? "" : " (yayında değil)"),
            value: Number(site.site_id),
        }));
    }

    /** "Siteye Git" butonu aktif şubenin alan adına gider */
    get activeSiteUrl(){
        let site = this.$store.getters.activeSite;
        if(site && site.domain){
            return "https://" + String(site.domain).replace(/^https?:\/\//, "");
        }
        return this.$store.state.siteUrl;
    }

    onSiteChange(siteId:number){
        this.$store.dispatch("changeSite", siteId);
    }

    setTheme(){
        localStorage.setItem("themeDark", this.$vuetify.theme.dark.toString());
    }
    created(){
        this.$vuetify.theme.dark = localStorage.getItem("themeDark") == "true";
    }
};
